import styled from 'styled-components';

export const ApricotBackground = styled.div`
  background-image: url('/background_one_person.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  margin: auto;
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media only screen and (max-width: 1450px) {
    background-size: cover;
    background-position: center center;
    background-image: url('/background.png');
    width: 100%;
  }
`;
